module.exports = __webpack_public_path__ + "static/media/bg_portateis.a7679d69.png";